import { render, staticRenderFns } from "./incomeTable.vue?vue&type=template&id=1edbb6f0&scoped=true&"
import script from "./incomeTable.vue?vue&type=script&lang=js&"
export * from "./incomeTable.vue?vue&type=script&lang=js&"
import style0 from "./incomeTable.vue?vue&type=style&index=0&id=1edbb6f0&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"
import style1 from "./incomeTable.vue?vue&type=style&index=1&id=1edbb6f0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edbb6f0",
  null
  
)

export default component.exports